// extracted by mini-css-extract-plugin
var _1 = "Columns_col__6d381";
var _2 = "Columns_content__21741";
export { _1 as "col", _2 as "content" }
